import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.activateItem = this.activateItem.bind(this);
    this.state = {
      selectedItem: undefined
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.pageKey !== this.props.pageKey) {
      this.setState({ selectedItem: 0 });
    }
  }
  activateItem(idx) {
    this.setState({ selectedItem: this.state.selectedItem === idx ? undefined : idx });
  }
  render() {
    const { items } = this.props;
    // featuring for style guide header updates
    return (
      <div className="accordion">
        {items &&
        items.map((item, index) => (
          <div className={`accordion-section ${index === this.state.selectedItem ? 'selected' : ''}`} key={index}>
            <h4 onClick={() => this.activateItem(index)} role="button" className="form-heading">
              <span>
                {item.heading}
              </span>
              <span className="pull-right">
                <i className={`zolaicon-public ${index === this.state.selectedItem ? 'zolaicon-public-minus' : 'zolaicon-public-plus'}`} />
              </span>
            </h4>
            <div className="accordion-body">
              <item.body {...item.props} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    body: PropTypes.func,
    props: PropTypes.shape({})
  })),
  pageKey: PropTypes.string
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/common/ui/Accordion.jsx